import { observer } from "mobx-react";

const FooterBase = () => {
    return <footer></footer>;
};

export const Footer = observer(FooterBase);
